<div class="app-toast-content" [attr.data-variant]="variant">
  <div class="app-toast-accent" aria-hidden="true">
    <kendo-icon-wrapper [svgIcon]="iconSvg" size="medium" />
  </div>
  <div class="app-toast-body">
    <div class="app-toast-body-content">
      <p class="app-toast-title">{{ title }}</p>
      @if (description) {
        <p class="app-toast-description">{{ description }}</p>
      }
    </div>
    @if (buttonAction) {
      <button
        kendoButton
        type="button"
        class="app-toast-action"
        (click)="buttonAction.onButtonClick()"
      >
        {{ buttonAction.label }}
      </button>
    }
    <button
      type="button"
      class="app-toast-dismiss"
      [attr.aria-label]="'Dismiss'"
      (click)="handleClose()"
    >
      <kendo-icon-wrapper [svgIcon]="xIcon" size="small" />
    </button>
  </div>
</div>
